import {
  PURCHASABLE,
  INSTORE_ONLY,
  MAX_ONLY,
  TRADE_ACCOUNT_ONLY,
  CREATIVE_GLASS_ONLY,
  ENQUIRE_ONLY
} from "./PurchaseControlTypes";

const PurchaseControl = ({
  type,
  renderPurchasable,
  renderInstoreOnly,
  renderMaxOnly,
  renderEnquireOnly,
  renderCreativeGlassOnly,
  renderTradeAccountOnly,
  children
}) => {
  switch (type) {
    case PURCHASABLE:
      return renderPurchasable();

    case INSTORE_ONLY:
      return renderInstoreOnly();

    case MAX_ONLY:
      return renderMaxOnly();

    case ENQUIRE_ONLY:
      return renderEnquireOnly();

    case CREATIVE_GLASS_ONLY:
      return renderCreativeGlassOnly();

    case TRADE_ACCOUNT_ONLY:
      return renderTradeAccountOnly();

    default:
      return children || false;
  }
};

export default PurchaseControl;
